<template>
  <CRow>
    <CCol col="12" xl="8">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Users
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="data"
            :fields="fields"
            column-filter
            table-filter
          >
          <template #reps="{item}">
            <td>
              <CButton size="sm" color="primary" @click="showRepList( item.id )">Rep List</CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
var methods = {}

methods.getUsers = function () {
  axios.get(this.$apiAdress +'/api/getCsrTable?token=' + localStorage.getItem('api_token'))
  .then(response => {
    console.log(response)
    this.data = response.data
  }).catch(e => {
    console.log(e)
  })
}

methods.showRepList = function (id) {
  this.$router.push('/csr_rep_list/' + id)
}

export default {
  name: 'CsrUsersTable',
  data() {
    return {
      data: [],
      fields: ['id', 'name', 'email', 'reps'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getUsers();
  }
}
</script>
